(function () {
  'use strict';

  angular
      .module('tfc.Toast',
      [
        'ui.router',
        'ui.bootstrap'
      ]);

})();
